/**
 * @prettier
 */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  getOrderedSteps,
  getCustomizations,
  getCustomizationTypeUUIDs,
  getPageEntities,
  getElementEntities,
} from '../../../../selectors/cardProjectSelector';
import { fetchCustomNotes } from '../../../../reducers/customization/actions';

import Loader from '../../../../../components/common/ui/Loader';

import { mobileScaleFactor, scaledStyle, ptToPx } from '../../../../util';
import { STEPS } from '../../../../constants/Steps';

import './ReviewPrintedMessages.less';

const ReviewPrintedMessages = ({
  busy,
  customizationEntities,
  elementEntities,
  pageEntities,
  customizationTypeToUUID,
  fetchCustomNotes, // eslint-disable-line
  notes,
  orderedSteps,
}) => {
  useEffect(() => {
    fetchCustomNotes();
  }, []);

  const [textStyles, setTextStyles] = useState({});
  const [cardStyles, setCardStyles] = useState({});

  useEffect(() => {
    const step = orderedSteps.find(s => s.id === STEPS.detailInside);

    if (!step) return;

    const customizationUUID = customizationTypeToUUID[step.cardType];
    const customization = customizationEntities[customizationUUID];
    const page = pageEntities[customization.pages[1]];
    const element = elementEntities[page.elements[0]];

    const pageMargin = 60;
    const scaleFactor = mobileScaleFactor(window.innerWidth - pageMargin, ptToPx(page.width));

    const scaledCardStyle = scaleFactor !== '1' ? scaledStyle(scaleFactor, page.height / 2) : null;

    setCardStyles({
      width: `${page.width}pt`,
      height: `${page.height / 2}pt`,
      ...scaledCardStyle,
    });
    setTextStyles({
      fontFamily: element.font.font_family,
      fontStyle: element.font.font_style,
      fontWeight: element.font.font_weight,
      fontSize: `${element.font_size}pt`,
      width: `${page.width - page.horizontal_bleed * 2}pt`,
      height: `${page.height / 2 - page.vertical_bleed * 2}pt`,
      lineHeight: `${element.line_height}pt`,
    });
  }, [orderedSteps]);

  if (busy) return <Loader />;

  return (
    <div className="review-custom-messages-modal">
      <div className="modal-header">
        <span className="header__title">
          <i className="zolaicon zolaicon-preview" /> You are in preview mode
        </span>
      </div>
      <div className="modal-body">
        {!notes ? (
          <span>No notes found.</span>
        ) : (
          Object.keys(notes).map(key => (
            <div key={key} className="custom-messages-preview-container" style={cardStyles}>
              <p style={textStyles}>{notes[key]}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    customizationEntities: getCustomizations(state),
    elementEntities: getElementEntities(state),
    pageEntities: getPageEntities(state),
    customizationTypeToUUID: getCustomizationTypeUUIDs(state),
    orderedSteps: getOrderedSteps(state),
    notes: state.cards.customization.review.notes,
    busy: state.cards.customization.busy,
  };
};

export default connect(mapStateToProps, { fetchCustomNotes })(ReviewPrintedMessages);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ReviewPrintedMessages/ReviewPrintedMessages.jsx